import { Action } from '@ngrx/store';

export enum SustainabilityActionTypes {
  LoadFollowParents = '[Sustainability] Load Sustainability',
  LoadFollowParentsSuccess = '[Sustainability] Load Sustainability Success',
  LoadFollowParentsFail = '[Sustainability] Load Sustainability Fail',

  LoadProvidersByParentId = '[Sustainability] Load Providers by ParentId',
  LoadProvidersByParentIdSuccess = '[Sustainability] Load Providers by ParentId Success',
  LoadProvidersByParentIdFail = '[Sustainability] Load Providers by ParentId Fail',

  ExportByProviderId = '[Sustainability] Export Sustainability by providerId',
  ExportByProviderIdSuccess = '[Sustainability] Export Sustainability by providerId Success',
  ExportByProviderIdFail = '[Sustainability] Export Sustainability by providerId Fail',

  ExportGroup = '[Sustainability] Export Sustainability Group',
  ExportGroupSuccess = '[Sustainability] Export Sustainability Group Success',
  ExportGroupFail = '[Sustainability] Export Sustainability Group Fail',
  ExportGroupPending = '[Sustainability] Export Sustainability Group pending',

  GetLink = '[Sustainability] Get Link Upload Group',
  GetLinkSuccess = '[Sustainability] Get Link Upload Group Success',
  GetLinkFail = '[Sustainability] Get Link Upload Group Fail',

  UploadGroup = '[Sustainability] Upload Group',
  UploadGroupSuccess = '[Sustainability] Upload Group Success',
  UploadGroupFail = '[Sustainability] Upload Group Fail',

  UploadingGroupSuccess = '[Sustainability] Upload Group success',
  UploadingGroupPending = '[Sustainability] Upload Group pending',
  UploadingGroupFail = '[Sustainability] Upload Group fail',

  ExportGroupDownload = '[Sustainability] Export Sustainability Group Download',
  ExportGroupDownloadSuccess = '[Sustainability] Export Sustainability Group Download Success',
  ExportGroupDownloadFail = '[Sustainability] Export Sustainability Group Download Fail',

  ExportConsolidate = '[Sustainability] Export consolidate',
  ExportConsolidateSuccess = '[Sustainability] Export consolidate Success',
  ExportConsolidateFail = '[Sustainability] Export consolidate Fail',

  UploadProcessFile = '[Sustainability] Upload Process File',
  UploadProcessFileSuccess = '[Sustainability] Upload Process File success',
  UploadProcessFileFail = '[Sustainability] Upload Process File fail',

  ClearState = '[Sustainability] Clear state',

  AcceptedChanges = '[Sustainability] Accepted changes for update',
  AcceptedChangesSuccess = '[Sustainability] Accepted changes for update success',
  AcceptedChangesFail = '[Sustainability] Accepted changes for update fail',
}

export class LoadFollowParents implements Action {
  readonly type = SustainabilityActionTypes.LoadFollowParents;
  constructor() {}
}

export class LoadFollowParentsSuccess implements Action {
  readonly type = SustainabilityActionTypes.LoadFollowParentsSuccess;
  constructor(public data: any) {}
}

export class LoadFollowParentsFail implements Action {
  readonly type = SustainabilityActionTypes.LoadFollowParentsFail;
  constructor(public error: any) {}
}

export class LoadProvidersByParentId implements Action {
  readonly type = SustainabilityActionTypes.LoadProvidersByParentId;
  constructor(public parentId: number) {}
}

export class LoadProvidersByParentIdSuccess implements Action {
  readonly type = SustainabilityActionTypes.LoadProvidersByParentIdSuccess;
  constructor(public data: any) {}
}

export class LoadProvidersByParentIdFail implements Action {
  readonly type = SustainabilityActionTypes.LoadProvidersByParentIdFail;
  constructor(public error: any) {}
}

export class ExportByProviderId implements Action {
  readonly type = SustainabilityActionTypes.ExportByProviderId;
  constructor(public parentId: number, public providerId: number, public providerName?: string) {}
}

export class ExportByProviderIdSuccess implements Action {
  readonly type = SustainabilityActionTypes.ExportByProviderIdSuccess;
  constructor() {}
}

export class ExportByProviderIdFail implements Action {
  readonly type = SustainabilityActionTypes.ExportByProviderIdFail;
  constructor(public error: any) {}
}

export class ExportGroup implements Action {
  readonly type = SustainabilityActionTypes.ExportGroup;
  constructor(public parentId: number, public data?: any) {}
}

export class ExportGroupPending implements Action {
  readonly type = SustainabilityActionTypes.ExportGroupPending;
  constructor(public data?: any) {}
}

export class ExportGroupSuccess implements Action {
  readonly type = SustainabilityActionTypes.ExportGroupSuccess;
  constructor(public data?: any) {}
}

export class ExportGroupFail implements Action {
  readonly type = SustainabilityActionTypes.ExportGroupFail;
  constructor(public error: any) {}
}

export class ExportGroupDownload implements Action {
  readonly type = SustainabilityActionTypes.ExportGroupDownload;
  constructor(public downloadUrl: any, public name: string, public total: number) {}
}

export class ExportGroupDownloadSuccess implements Action {
  readonly type = SustainabilityActionTypes.ExportGroupDownloadSuccess;
  constructor(public data?: any) {}
}

export class ExportGroupDownloadFail implements Action {
  readonly type = SustainabilityActionTypes.ExportGroupDownloadFail;
  constructor(public error: any) {}
}

export class ExportConsolidate implements Action {
  readonly type = SustainabilityActionTypes.ExportConsolidate;
  constructor(public parentId: any) {}
}

export class ExportConsolidateSuccess implements Action {
  readonly type = SustainabilityActionTypes.ExportConsolidateSuccess;
  constructor(public data?: any) {}
}

export class ExportConsolidateFail implements Action {
  readonly type = SustainabilityActionTypes.ExportConsolidateFail;
  constructor(public error: any) {}
}

export class GetLink implements Action {
  readonly type = SustainabilityActionTypes.GetLink;
  constructor(public file: any, public parentId: number) {}
}

export class GetLinkSuccess implements Action {
  readonly type = SustainabilityActionTypes.GetLinkSuccess;
  constructor(public data?: any) {}
}

export class GetLinkFail implements Action {
  readonly type = SustainabilityActionTypes.GetLinkFail;
  constructor(public error?: any) {}
}

export class UploadGroup implements Action {
  readonly type = SustainabilityActionTypes.UploadGroup;
  constructor(public link: string, public fileId: number, public file: any, public parentId: any) {}
}

export class UploadGroupSuccess implements Action {
  readonly type = SustainabilityActionTypes.UploadGroupSuccess;
  constructor(public fileId: any, public parentId: any) {}
}

export class UploadGroupFail implements Action {
  readonly type = SustainabilityActionTypes.UploadGroupFail;
  constructor(public error?: any) {}
}

export class UploadingGroupSuccess implements Action {
  readonly type = SustainabilityActionTypes.UploadingGroupSuccess;
  constructor(public data?: any) {}
}

export class UploadingGroupPending implements Action {
  readonly type = SustainabilityActionTypes.UploadingGroupPending;
  constructor(public data?: any) {}
}

export class UploadingGroupFail implements Action {
  readonly type = SustainabilityActionTypes.UploadingGroupFail;
  constructor(public error?: any) {}
}

export class UploadProcessFile implements Action {
  readonly type = SustainabilityActionTypes.UploadProcessFile;
  constructor(public data?: any) {}
}

export class UploadProcessFileSuccess implements Action {
  readonly type = SustainabilityActionTypes.UploadProcessFileSuccess;
  constructor(public data?: any) {}
}

export class UploadProcessFileFail implements Action {
  readonly type = SustainabilityActionTypes.UploadProcessFileFail;
  constructor(public error?: any) {}
}

export class ClearState implements Action {
  readonly type = SustainabilityActionTypes.ClearState;
  constructor() {}
}

export class AcceptedChanges implements Action {
  readonly type = SustainabilityActionTypes.AcceptedChanges;
  constructor(public data?: any) {}
}

export class AcceptedChangesSuccess implements Action {
  readonly type = SustainabilityActionTypes.AcceptedChangesSuccess;
  constructor(public data?: any) {}
}

export class AcceptedChangesFail implements Action {
  readonly type = SustainabilityActionTypes.AcceptedChangesFail;
  constructor(public error?: any) {}
}

export type SustainabilityActionsUnion = 
  LoadFollowParents 
| LoadFollowParentsSuccess 
| LoadFollowParentsFail
| LoadProvidersByParentId
| LoadProvidersByParentIdSuccess
| LoadProvidersByParentIdFail
| ExportByProviderId
| ExportByProviderIdSuccess
| ExportByProviderIdFail
| UploadProcessFile
| UploadProcessFileSuccess
| UploadProcessFileFail
| ClearState
| AcceptedChanges
| AcceptedChangesSuccess
| AcceptedChangesFail
| ExportGroup
| ExportGroupSuccess
| ExportGroupFail
| ExportGroupPending
| ExportGroupDownload
| ExportGroupDownloadSuccess
| ExportGroupDownloadFail
| GetLink
| GetLinkSuccess
| GetLinkFail
| UploadGroup
| UploadGroupSuccess
| UploadGroupFail
| UploadingGroupSuccess
| UploadingGroupPending
| UploadingGroupFail
| ExportConsolidate
| ExportConsolidateSuccess
| ExportConsolidateFail;
